import { Outlet } from "react-router"

import { AppError } from "../../app/AppError"
import { NotFound } from "../not-found/NotFound"
import { GiftCardDetail } from "./GiftCardDetail"

export const giftCardRouter = [
  {
    path: "",
    errorElement: (
      <AppError />
    ),
    element: (
      <Outlet />
    ),
    children: [
      {
        path: "",
        element: (
          <GiftCardDetail />
        ),
      },
      {
        path: "*",
        element: (
          <NotFound />
        )
      },
    ]
  },
]
